module.exports = __webpack_public_path__ + "img/logo-red.d8cc4ab6.png";